<template>
	<v-container>
		<v-row>
			<v-col cols="4">
				<v-card width="400">
					<v-img height="325px" src="https://cdn.pixabay.com/photo/2020/07/12/07/47/bee-5396362_1280.jpg" cover>
						<v-app-bar flat color="rgba(0, 0, 0, 0)">
							<v-app-bar-nav-icon color="white"></v-app-bar-nav-icon>

							<v-toolbar-title class="text-h6 text-white pl-0"> Messages </v-toolbar-title>

							<v-spacer></v-spacer>

							<v-btn color="white" icon="mdi-dots-vertical"></v-btn>
						</v-app-bar>

						<v-card-title class="text-white mt-8">
							<v-avatar size="56">
								<img alt="user" src="https://cdn.pixabay.com/photo/2020/06/24/19/12/cabbage-5337431_1280.jpg" />
							</v-avatar>
							<p class="ml-3">John Doe</p>
						</v-card-title>
					</v-img>

					<v-card-text>
						<div class="font-weight-bold ml-8 mb-2">Today</div>

						<v-timeline align="start" dense>
							<v-timeline-item v-for="message in messages" :key="message.time" :color="message.color" size="small">
								<div>
									<div class="font-weight-normal">
										<strong>{{ message.from }}</strong> @{{ message.time }}
									</div>
									<div>{{ message.message }}</div>
								</div>
							</v-timeline-item>
						</v-timeline>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="8">
				<v-card :loading="loading" class="mx-auto">
					<template v-slot:progress>
						<v-progress-linear color="deep-purple" height="10" indeterminate></v-progress-linear>
					</template>

					<v-img height="250" src="https://cdn.vuetifyjs.com/images/cards/cooking.png" cover></v-img>

					<v-card-title>Cafe Badilico</v-card-title>

					<v-card-text>
						<v-row align="center" class="mx-0">
							<v-rating :model-value="4.5" color="amber" dense half-increments readonly size="14"></v-rating>

							<div class="text-grey-darken-1 ml-4">4.5 (413)</div>
						</v-row>

						<div class="my-4 text-subtitle-1">$ • Italian, Cafe</div>

						<div>Small plates, salads & sandwiches - an intimate setting with 12 indoor seats plus patio seating.</div>
					</v-card-text>

					<v-divider class="mx-4"></v-divider>

					<v-card-title>Tonight's availability</v-card-title>

					<v-card-text>
						<v-chip-group v-model="selection" selected-class="bg-deep-purple-accent-4 text-white" column>
							<v-chip>5:30PM</v-chip>

							<v-chip>7:30PM</v-chip>

							<v-chip>8:00PM</v-chip>

							<v-chip>9:00PM</v-chip>
						</v-chip-group>
					</v-card-text>

					<v-card-actions>
						<v-btn color="deep-purple-lighten-2" variant="text" @click="reserve"> Reserve </v-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Home',
	data: () => ({
		loading: false,
		selection: 1,
		messages: [
			{
				from: 'You',
				message: `Sure, I'll see you later.`,
				time: '10:42am',
				color: 'deep-purple-lighten-1',
			},
			{
				from: 'John Doe',
				message: 'Yeah, sure. Does 1:00pm work?',
				time: '10:37am',
				color: 'green',
			},
			{
				from: 'You',
				message: 'Did you still want to grab lunch today?',
				time: '9:47am',
				color: 'deep-purple-lighten-1',
			},
		],
	}),
	methods: {
		reserve() {
			this.loading = true;

			setTimeout(() => (this.loading = false), 2000);
		},
	},
};
</script>
